module.exports = __webpack_public_path__ + "img/area-5-video2-cover.9484fae.jpg";